module.exports = __webpack_public_path__ + "img/staff-2006-jiaozuo.14f1d368.jpg";